(() => {
  if (customElements.get('parfimo-infinite-scroll')) return;

  class ParfimoInfiniteScroll extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;

      this.busy = false;
      this.failed = false;
      this.loaded = new Set();
      this.container = this.closest('#ProductGridContainer');
      this.fallback = this.querySelector('[data-pagination-fallback]');
      this.status = this.querySelector('[data-scroll-status]');

     this.fallback.hidden = false; 
     this.style.display = 'block';

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.loadNext();
          }
        },
        { rootMargin: '400px 0px' }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }

    async loadNext() {
      if (
        this.busy ||
        this.failed ||
        !this.dataset.nextUrl ||
        !this.isConnected
      ) {
        return;
      }

      if (this.container.querySelector('.collection.loading')) return;

      const originalSearch = location.search;
      const originalPath = location.pathname;
      const nextUrl = new URL(this.dataset.nextUrl, location.origin);

      if (
        nextUrl.origin !== location.origin ||
        this.loaded.has(nextUrl.href)
      ) {
        return;
      }

      this.busy = true;
      this.controller = new AbortController();
      this.status.textContent = this.dataset.loadingText;
      this.setAttribute('aria-busy', 'true');

      try {
        const requestUrl = new URL(nextUrl);
        requestUrl.searchParams.set(
          'section_id',
          this.dataset.sectionId
        );

        const response = await fetch(requestUrl, {
          signal: this.controller.signal
        });

        if (!response.ok) {
          throw new Error('Collection request failed');
        }

        const html = new DOMParser().parseFromString(
          await response.text(),
          'text/html'
        );

        if (
          !this.isConnected ||
          location.search !== originalSearch ||
          location.pathname !== originalPath ||
          this.container.querySelector('.collection.loading')
        ) {
          return;
        }

        const grid = this.container.querySelector('ul#product-grid');
        const incoming = html.querySelector('ul#product-grid');

        if (!grid || !incoming) {
          throw new Error('Collection grid missing');
        }

        const fragment = document.createDocumentFragment();

        Array.from(incoming.children).forEach((card) => {
          card.classList.remove(
            'animate-item',
            'animate-item--child'
          );
          card.style.removeProperty('--index');
          fragment.appendChild(card);
        });

        grid.appendChild(fragment);
        this.loaded.add(nextUrl.href);

        const next = html.querySelector('parfimo-infinite-scroll');
        this.dataset.nextUrl = next?.dataset.nextUrl || '';

        if (next) {
          this.fallback.innerHTML = next.querySelector(
            '[data-pagination-fallback]'
          ).innerHTML;
        }

        if (!this.dataset.nextUrl) {
          this.observer.disconnect();
          this.hidden = true;
          this.style.display = 'none';
        }
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.failed = true;
          this.observer.disconnect();
          this.fallback.hidden = false;
        }
      } finally {
        this.busy = false;
        this.status.textContent = '';
        this.removeAttribute('aria-busy');

        if (
          this.isConnected &&
          !this.failed &&
          this.dataset.nextUrl &&
          this.getBoundingClientRect().top < innerHeight + 400
        ) {
          requestAnimationFrame(() => this.loadNext());
        }
      }
    }
  }

  customElements.define(
    'parfimo-infinite-scroll',
    ParfimoInfiniteScroll
  );
})();